<template>
  <div v-if="state.descendants.length > 0">
    <div class="flex flex-col space-x-6 xl:justify-center xl:flex-row px-4 py-8">
      <article class="w-full mt-8 xl:mt-0">
        <section class="container-1024 m-auto ">
          <div class="mx-auto container-1024">
            <nav class="flex flex-wrap items-center justify-center">
              <a v-for="(item, index) in state.descendants"
                :key=index
                :href="item.slug"
                class="w-menu-icon h-menu-icon m-1 inline-table align-top text-brand consignado-icon text-center border-4 border-gray-300 rounded-xl relative hover:border-brand"
                :title="item.name"
                style="width: 150px; height:150px; margin-bottom: 20px;"
              >
              <img class="rounded-xl z-1n" :src="item.icon_area_path_cache || require('../../assets/images/no-image.png')"/>
              </a>
            </nav>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>
<script>
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/services'

export default {
    setup() {
        const route = useRoute()

        const state = reactive({
            descendants: []
        })

        api.menu.subArea(route.params.slug).then(result => {
          if (result !== undefined) {
            var areaCategory = result[0]
            state.descendants = areaCategory ? areaCategory.descendants : []
          }
        })

        return {state}
    }
}
</script>